<script lang="ts">
  import { browser } from '$app/environment';
  import Cropper from 'cropperjs';
  import 'cropperjs/dist/cropper.min.css';
  import Button from '../Button.svelte';

  export let showImageEditing = false;
  // This refers to a view mode where the cropper is front and center, like during onboarding.
  // As opposed to the version that's rendered in a slideover for profile editing.
  export let isFullSize = false;
  export let originalImage: FileList | null = null;
  export let croppedImage: FileList | null;

  let img: HTMLImageElement;
  let cropper: Cropper;
  $: if (browser && img) {
    cropper = new Cropper(img, {
      aspectRatio: 1 / 1,
      viewMode: 2,
      dragMode: 'move',
    });
  }
  const setCroppedImage = async () => {
    try {
      if (!originalImage || !originalImage[0]) return;

      const dataURI = cropper.getCroppedCanvas().toDataURL(originalImage[0].type);
      const res = await fetch(dataURI);
      const buffer = await res.arrayBuffer();
      const file = new File([buffer], originalImage[0].name, {
        type: originalImage[0].type,
      });

      // Create object that conforms to the minimal FileList interface needed
      const fileListLike = {
        length: 1,
        [0]: file,
        item: () => file,
        // Add a simple iterator to satisfy the FileList interface
        *[Symbol.iterator]() {
          yield file;
        },
      } as unknown as FileList;

      croppedImage = fileListLike;
      showImageEditing = false;
    } catch (error) {
      console.log('Conversion error', error);
    }
  };
</script>

{#if isFullSize}
  <!-- Background blur and cover -->
  <div class="absolute inset-0 z-20 flex items-center justify-center backdrop-blur-[3px]"></div>
{/if}
<div
  class="bg-gray-dark-0 absolute inset-0 z-50 flex flex-col gap-4 p-4 {isFullSize
    ? 'max-h-screen sm:left-[20%] sm:right-[20%] sm:max-h-[50%]'
    : 'max-h-screen'}"
>
  {#if isFullSize}
    <div class="flex w-full items-center justify-end gap-x-4">
      <Button
        tertiary
        on:click={() => {
          originalImage = null;
          showImageEditing = false;
        }}>Cancel</Button
      >
      <Button secondary on:click={setCroppedImage}>Apply</Button>
    </div>
  {/if}
  <div class="block h-[calc(100%_-_48px)]">
    {#if originalImage?.[0]}
      <img
        src={URL.createObjectURL(originalImage[0])}
        alt=""
        bind:this={img}
        class="block h-full w-full max-w-full object-cover"
      />
    {/if}
  </div>
  {#if !isFullSize}
    <div class="flex w-full items-center justify-end gap-x-4">
      <Button
        tertiary
        on:click={() => {
          originalImage = null;
          showImageEditing = false;
        }}>Cancel</Button
      >
      <Button secondary on:click={setCroppedImage}>Apply</Button>
    </div>
  {/if}
</div>
